/* 
Allows the connected wallet to decrease their stake at the current Orchestrator
*/
import { Stack, Text } from "@mantine/core";
import { useBondingManager } from "../../../hooks/WithSmartContracts";
import { useState } from "react";
import { ethers } from "ethers";
import TextToNumberInput from "../components/TextToNumberInput";
import SmartContractAction from "../components/SmartContractAction";

export default function Unbond(props) {
  const [isPending, setIsPending] = useState(false);
  const [thisTxn, setTxn] = useState("");
  const [thisErrMsg, setErrMsg] = useState("");
  const [isFinished, setIsFinished] = useState(false);
  const bondingManager = useBondingManager();

  const unbondLPT = async () => {
    if (!props.inputValue || props.inputValue == 0) {
      return;
    }
    try {
      const { ethereum } = window;
      if (ethereum) {
        const thisValue = ethers.utils.parseEther(props.inputValue.toString());
        setIsPending(true);
        let hints = null;
        if (props.getHints) {
          hints = props.getHints(-thisValue, "", props.orchestratorAddr);
        }
        console.log("Calculated hints:");
        console.log(hints);
        if (hints) {
          const txn = await bondingManager.unbondWithHint(
            thisValue,
            hints.newDelegateNewPosPrev,
            hints.newDelegateNewPosNext
          );
          setTxn(txn.hash);
          await txn.wait();
        } else {
          const txn = await bondingManager.unbond(thisValue);
          setTxn(txn.hash);
          await txn.wait();
        }
        props.refreshWallet();
        setIsFinished(true);
      }
    } catch (error) {
      if (error.reason) {
        setErrMsg(error.reason);
      }
      props.setErr(true);
      setIsPending(false);
      setTxn(false);
      setIsFinished(false);
    }
  };

  if (!props.delegatorState) {
    return (
      <Stack spacing={24}>
        <Text size="xl" fw={700}>
          Your account is in a pending state. You can Unbond during the next
          round
        </Text>
      </Stack>
    );
  } else {
    return (
      <Stack spacing={24}>
        <TextToNumberInput
          inputValue={props.inputValue}
          setInput={props.setInput}
          min={0}
          max={props.balance / ethers.constants.WeiPerEther}
          placeholder={"LPT"}
          description={
            (props.balance / ethers.constants.WeiPerEther).toFixed(2) +
            " LPT is currently staked"
          }
          label={"Lower your LPT staked"}
        />
        <SmartContractAction
          isPending={isPending}
          txn={thisTxn}
          thisErrMsg={thisErrMsg}
          isFinished={isFinished}
          action={unbondLPT}
          actionMessage={"Remove " + props.inputValue + " LPT stake"}
          finishedMessage={"Successfully decreased stake!"}
          pendingMessage={"Decreasing Delegated Stake..."}
        />
        {thisErrMsg != "" ? (
          <Text size="xl" fw={700}>
            The previous transaction failed with reason `{thisErrMsg}`
          </Text>
        ) : null}
      </Stack>
    );
  }
}
